import React from 'react';
import { Bell } from 'lucide-react';
import { usePermissions } from '../../utils/usePermissions';
import { useNotificationsUnreadCount } from '../../contexts/NotificationsContext';
import './NotificationBell.css';

export interface NotificationBellProps {
  variant: 'sidebar' | 'mobile';
  onClick: () => void;
  isOpen?: boolean;
}

export const NotificationBell: React.FC<NotificationBellProps> = ({
  variant,
  onClick,
  isOpen = false,
}) => {
  const { hasPermission } = usePermissions();
  const unreadCount = useNotificationsUnreadCount();

  if (!hasPermission('notifications:read')) return null;

  const displayCount = unreadCount > 99 ? '99+' : String(unreadCount);

  const ariaLabel = unreadCount > 0
    ? `Уведомления, ${unreadCount} непрочитанных`
    : 'Уведомления';

  const classNames = [
    'notif-bell',
    variant === 'mobile' ? 'notif-bell--mobile' : '',
    isOpen ? 'is-active' : '',
  ].filter(Boolean).join(' ');

  return (
    <button
      type="button"
      className={classNames}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-haspopup="true"
      aria-expanded={isOpen}
    >
      <Bell size={14} />
      {unreadCount > 0 && (
        <span className="notif-bell__badge" aria-live="polite">
          {displayCount}
        </span>
      )}
    </button>
  );
};

export default NotificationBell;
